// extracted by mini-css-extract-plugin
export default {"container":"SponsorArea_container__hiqSx","sponsor":"SponsorArea_sponsor__xi+BM","sponsor-swiper":"SponsorArea_sponsor-swiper__Mxs-Z"};